import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";

function normalizeText(value) {
  if (value === null || value === undefined || value === false) return "";
  return String(value).trim();
}

function formatOdooPartnerAddress(partner) {
  const street = normalizeText(partner.street);
  const street2 = normalizeText(partner.street2);
  const city = normalizeText(partner.city);
  const zip = normalizeText(partner.zip);
  const country = Array.isArray(partner.country_id)
    ? normalizeText(partner.country_id[1])
    : normalizeText(partner.country_id);
  const email = normalizeText(partner.email);
  const phone = normalizeText(partner.phone);

  return [
    [street, street2].filter(Boolean).join(" "),
    [city, zip].filter(Boolean).join(", "),
    country,
    email,
    phone,
  ]
    .filter(Boolean)
    .join("\n");
}

const FETCH_CUSTOMER_ADDRESSES = gql`
  query FetchCustomerAddresses($odooPartnerId: Int!) {
    odooCustomerAddresses(odooPartnerId: $odooPartnerId)
  }
`;

const CustomerAddressSelector = ({ customer, onSelect }) => {
  const { loading, error, data } = useQuery(FETCH_CUSTOMER_ADDRESSES, {
    variables: { odooPartnerId: customer.odooPartnerId },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.odooCustomerAddresses).map((i) => ({
    ...i,
    address: formatOdooPartnerAddress(i),
  }));

  const addressByTypes = res.reduce((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = [];
    }
    acc[item.type].push(item);
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      {Object.keys(addressByTypes).map((type) => (
        <div key={type}>
          <h5 className="capitalize">{type}</h5>
          <div className="mt-2 -mx-2 grid grid-cols-2 gap-6 border-t dark:border-gray-700 pt-4">
            {addressByTypes[type].map((i) => (
              <div
                key={i.id}
                onClick={() => onSelect(i)}
                className="card border hover:border-blue-500 dark:hover:border-blue-400 cursor-pointer"
              >
                <b>{i.name}</b>
                <div className="whitespace-pre-wrap">{i.address}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerAddressSelector;
